<template>
    <!-- <p v-if="false">{{ model }}</p> -->
    <!-- <TextInput v-if="visible" v-model="model.DocNo" :name="name" :rules="{ required: true, alphanumeric: true }" :id='id'
        :required-icon="true" @update:modelValue="update" disabled /> -->
    <p class="common-heading">{{ model.DocNo }}</p>
    <!-- <p>{{ model.DocNo }}</p> -->
</template>
<script lang="ts">
import TextInput from "../FormComponents/TextInput.vue";
import common from "../../modules/Inventory/Service/CommonService";
import { defineComponent, ref, reactive, toRefs, onMounted, watch } from 'vue'
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
    components: {
        TextInput,
    },
    props: {
        value: {},
        input: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: '',
        },

        id: {
            type: String,
            default: '',
        },
        FormId: {
            type: String,
            default: '',
        },
        modelValue: {
            type: String
        },
        visible: {
            type: Boolean,
            default: false
        }
    },

    setup(props, { emit }) {
        debugger;
        //Session Hospital&Branch ID
        let session: any = localStorage.getItem('UsersData')

        session = JSON.parse(session)
        let HospitalId = Number(session.OrganizationId);
        let BranchId = Number(session.BranchId);
        let UserId = Number(session.UserId)
        const model = ref({
            DocNo: props.modelValue === "" ? "" : props.modelValue
        });
        const route = useRoute();
        let queryBranchId = Number(route.query.BranchId ?? 0)

        watch(
            () => props.modelValue,
            (newVal: any) => {
                debugger;

                model.value.DocNo = newVal;
                update();
                // if (!newVal) {
                //     GetCode(props.FormId)
                // }
                // else {
                //     model.DocNo = newVal;
                //     update();
                // }
            }, { deep: true }
        );
        watch(
            () => props.FormId,
            (newVal: any) => {
                debugger;
                GetCode(newVal)

            }, { deep: true }
        );


        const id = ref();
        onMounted(() => {
            if (props.modelValue == "") {
                GetCode(props.FormId)
            }

        })
        async function GetCode(val) {
            debugger;
            let data = {
                EntityId: val,
                HospitalId: HospitalId,
                BranchId: queryBranchId,
                StoreId: route.query.StoreId ?? 0
            };
            let result: any = await common.getCodeTemplate(data);
            console.log(result);
            model.value.DocNo = result;
            update()
        }
        function update() {
            debugger;
            emit("update:modelValue", model.value.DocNo);
        }
        return {
            model,
            update,
            id,
            GetCode
        };
    }

})
</script>
